export class PrinterListModalCtrl {

    constructor ($uibModalInstance, R, company, request, PrinterStore) {
        "ngInject";
        let self = this;

        self.store = PrinterStore;
        self.$modal = $uibModalInstance;
        self.R = R;
        self.loading = true;
        self.sendingRequest = false;
        self.selectedPrinter = null;
        self.hasErrors = false;
        self.errorMessage = '';
        self.store.init();
        self.store.params.company = company;
        self.store.params.status = 'online';

        self.store.refresh();
        self.store.$promise.then(
            () => {
                self.hasErrors = false;
                self.errorMessage = '';
            },
            (response) => {
                if (response.status === 403) {
                    self.hasErrors = true;
                    self.errorMessage = 'You are not connected to PrintNode, please connect first';
                }
            }).finally(() => self.loading = false);

        self.request = request;
    }

    get title () {
        return `Select Printer`;
    }

    resetErrors () {
        this.hasErrors = false;
        this.errorMessage = ''
    }

    selectPrinter (id) {
        if (this.selectedPrinter === id) {
            // Unselect
            this.selectedPrinter = null;
            return;
        }
        this.selectedPrinter = id;
    }

    close () {
        this.$modal.dismiss();
    }

    getEndpoint (type, order) {
        if (type === 'estimate') {
            return order.all('estimate').all('print');
        } else {
            return order.all('form').all('print');
        }
    }

    getPromise (order) {
        let self = this;

        let endpoint = this.getEndpoint(self.request.type, order);
        return endpoint.post(_.extend({
            printer: self.selectedPrinter,
        }), self.request.params || {})
    }

    submit () {
        let self = this;

        if (self.request.multiple) {
            this.submitMultiple();
        } else {
            this.submitOne();
        }
    }

    submitOne () {
        let self = this;

        self.resetErrors();
        self.sendingRequest = true;
        self.request.endpoint.post(_.extend({
            printer: self.selectedPrinter,
        }), self.request.params || {})
        .then(
            () => {
                self.$modal.close(true);
            },
            (response) => {
                if (response.status === 403) {
                    self.hasErrors = true;
                    self.errorMessage = 'Looks like you are not connected to PrintNode. Please contact administrator';
                }
            }
        )
        .finally(() => self.sendingRequest = false);
    }

    getInitialButtonState(orderId) {
        return {
            id: orderId,
            status: 'sending',
            class: {'btn-primary': true, 'btn-success': false, 'btn-danger': false},
            msg: `Order ${orderId}: Sending`,
            loading: true
        };
    }

    getSuccessButtonState(orderId) {
        return {
            id: orderId,
            status: 'success',
            class: {'btn-primary': false, 'btn-success': true, 'btn-danger': false},
            msg: `Order ${orderId}: Success!`
        };
    }

    getErrorButtonState(orderId) {
        return {
            id: orderId,
            status: 'error',
            class: {'btn-primary': false, 'btn-success': false, 'btn-danger': true},
            msg: `Order ${orderId}: Error occured!`
        };
    }

    canModalBeClosed () {
        let self = this;

        let statusArr = Object.values(self.sendStatus).map(item => item.status);
        return statusArr.every(item => item === 'success');
    }

    submitMultiple () {
        let self = this;

        self.resetErrors();
        self.sendingRequest = true;
        if (self.request.orders && self.request.type) {
            self.sendStatus = {};
            angular.forEach(self.request.orders, function (order) {
                self.sendStatus[order.id] = self.getInitialButtonState(order.id);
                self.oneOrder = Object.keys(self.sendStatus).length === 1;
                self.getPromise(order)
                .then(
                    () => {
                        self.sendStatus[order.id] = self.getSuccessButtonState(order.id);
                    },
                    (response) => {
                        self.sendStatus[order.id] = self.getErrorButtonState(order.id);
                        if (response.status === 403) {
                            // Google Cloud Print message
                        }
                    }
                )
                .finally(() => {
                    self.sendingRequest = false;
                    self.sendStatus[order.id].loading = false;
                    if (self.canModalBeClosed()) {
                        self.$modal.close(Object.keys(self.sendStatus).length);
                    }
                })
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/printers/ctrls.js